/**
 * @generated SignedSource<<4f017f7f5e88b5839e86dbb11f581332>>
 * @relayHash fd0e173add2087e14fa1598bb5486acb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c8c174a3ee3b07d5c0583bba9c8718da7a0a1b149f9313d0644313d5e01f6beb

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type ContentStateInput = {
  color?: string | null | undefined;
  id?: AGG$Long | null | undefined;
  name?: string | null | undefined;
  spaceKey?: string | null | undefined;
};
export type EditorContentStateComponentSetContentStateAndPublishMutation$variables = {
  contentId: string;
  contentStateInput: ContentStateInput;
  suppressDraftPropertyUpdate?: boolean | null | undefined;
};
export type EditorContentStateComponentSetContentStateAndPublishMutation$data = {
  readonly setContentStateAndPublish: {
    readonly color: string;
    readonly id: string | null | undefined;
    readonly name: string;
    readonly restrictionLevel: ContentStateRestrictionLevel;
  } | null | undefined;
};
export type EditorContentStateComponentSetContentStateAndPublishMutation = {
  response: EditorContentStateComponentSetContentStateAndPublishMutation$data;
  variables: EditorContentStateComponentSetContentStateAndPublishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentStateInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "suppressDraftPropertyUpdate"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentState",
        "variableName": "contentStateInput"
      },
      {
        "kind": "Variable",
        "name": "suppressDraftPropertyUpdate",
        "variableName": "suppressDraftPropertyUpdate"
      }
    ],
    "concreteType": "ContentState",
    "kind": "LinkedField",
    "name": "setContentStateAndPublish",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "color"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "restrictionLevel"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fd0e173add2087e14fa1598bb5486acb",
    "id": "c8c174a3ee3b07d5c0583bba9c8718da7a0a1b149f9313d0644313d5e01f6beb",
    "metadata": {},
    "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
    "operationKind": "mutation",
    "text": "mutation EditorContentStateComponentSetContentStateAndPublishMutation($contentId:ID!,$contentStateInput:ContentStateInput!,$suppressDraftPropertyUpdate:Boolean){setContentStateAndPublish(contentId:$contentId,contentState:$contentStateInput,suppressDraftPropertyUpdate:$suppressDraftPropertyUpdate){name,color,id,restrictionLevel}}"
  }
};
})();

(node as any).hash = "f68aac35b0fcae3fcbf7a0d2343062a9";

export default node;
